import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';
import whoWeServeSectionBackground from '../../../../../assets/images/who_we_serve.webp';
import { colors, fontFamilies } from '../../../../../constants/theme';
import { figmaLetterSpacing, Gapper } from '../../../../../ui/utils';

export const WhoWeServeSectionWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(4),
  background: `linear-gradient(180deg, rgba(82, 31, 12, 0.4) 0%, rgba(82, 31, 12, 0.4) 100%), url(${whoWeServeSectionBackground})`,
  maxWidth: 1400,
  maxHeight: 789,
  width: '100%',
  height: '100vh',
  boxShadow: `
    -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15),
     4px  4px 15px   0px rgba(205, 214, 223, 0.25)
  `,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: 20,
  [theme.breakpoints.down('md')]: {
    maxHeight: 'none',
    height: 'auto',
    minHeight: '500px',
    borderRadius: 16,
    padding: '60px 40px',
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '400px',
    borderRadius: 12,
    padding: '40px 24px',
  },
  '& .MuiButtonBase-root': {
    color: colors.whiteText,
    borderColor: colors.whiteText,
    '&:hover': {
      backgroundColor: 'rgba(82, 31, 12, 0.4)',
    },
  },
}));

export const OuterGapper = styled(Gapper)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'center',
  gap: 90,
  [theme.breakpoints.down('lg')]: {
    gap: 50,
  },
  [theme.breakpoints.down('md')]: {
    gap: 30,
  },
  [theme.breakpoints.down('sm')]: {
    gap: 10,
  },
}));

export const InnerGapper = styled(Gapper)(({ theme }) => ({
  gap: 50,
  maxWidth: '450px',
  alignItems: 'flex-start',
  justifyContent: 'center',
  [theme.breakpoints.down('lg')]: {
    gap: 30,
  },
  [theme.breakpoints.down('md')]: {
    gap: 20,
  },
}));


export const SectionDescription = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies?.gotham,
  color: colors.whiteText,
  fontWeight: 400,
  letterSpacing: figmaLetterSpacing(23, -1),
  maxWidth: '560px',
  fontSize: '32px',
  lineHeight: '41px',
  textTransform: 'capitalize',

  [theme.breakpoints.down('lg')]: {
    fontSize: '23px',
    lineHeight: '32px',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
    lineHeight: '24px',
  },
}));

export const ButtonWrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: 'max-content',
  }
}));
